<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="图例名字">
              <a-input v-model="query.legendName" placeholder="请输入图例名字" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="edit()">新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <div slot="styleValue" slot-scope="text, record">
        <div v-if="record.type === 'point'"
          style="width:50px;height:50px;border-radius:4px;background:#ECEFF3;display:flex;justify-content: center;align-items: center;">
          <template v-if="text">
            <!-- 外部链接 -->
            <img v-if="text.includes('http') || text.includes('//')" :src="text" width="40" height="40" alt="加载失败" />
            <!-- 颜色块 -->
            <div v-else-if="text.startsWith('color:')"
              :style="{ backgroundColor: text.split(':')[1], width: '30px', height: '30px', borderRadius: '50%', border: '1px solid #ddd' }">
            </div>
            <!-- 本地 png 图标（已废弃，显示占位符） -->
            <div v-else-if="text.endsWith('.png')"
              style="width: 40px; height: 40px; background: #f0f0f0; display: flex; align-items: center; justify-content: center; border-radius: 4px; color: #999; font-size: 12px;">
              图标
            </div>
            <span v-else>{{ text }}</span>
          </template>
        </div>
        <div v-else-if="record.type === 'line'" style="width:50px;height:50px;">
          <svg style="margin-left: -10px;width:100%; height:50%">
            <g fill="none" :stroke="text | lineStyle1">
              <path :stroke-width="text | lineStyle2" d="M0 15 l65 0" :stroke-dasharray='text | lineStyle3' />
            </g>
          </svg>
          <svg style="margin-left: -10px;width:100%; height:50%" viewBox="-3 2 22 3">
            <g fill="none" :stroke="text | lineStyle1">
              <path d="M3,5 l1,-3 l1,3" :stroke-linejoin='text | lineStyle4' />
            </g>
          </svg>
        </div>
      </div>
      <div slot="defaultShow" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'orange'">{{ text === 1 ? '是' : '否' }}</a-tag>
      </div>
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record.id)">编辑</a>
      </span>
    </a-table>
    <a-modal title="GIS编辑图例操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图例名字">
          <a-input placeholder="图例名字"
            v-decorator="['legendName', { rules: [{ required: true, message: '请输入图例名字' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型">
          <a-select placeholder="请选择类型" v-decorator="['type', { rules: [{ required: true, message: '请选择类型' }] }]">
            <a-select-option value="point">点</a-select-option>
            <a-select-option value="line">线</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配置项">
          <a-input placeholder="对应 MappingTable 中的 config" v-decorator="['config']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
          <a-input-number :min="0" style="width: 100%" placeholder="请输入排序值"
            v-decorator="['sort', { initialValue: 0 }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认显示">
          <a-switch v-decorator="['defaultShow', { valuePropName: 'checked', initialValue: true }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联样式">
          <div v-if="editingStyle" class="selected-layer">
            <template v-if="addOrUpdateForm.getFieldValue('type') === 'point'">
              <div v-if="editingStyle.styleValue"
                style="width:24px;height:24px;border-radius:4px;background:#ECEFF3;display:flex;justify-content: center;align-items: center;margin-right: 8px;flex-shrink: 0;">
                <!-- 外部链接 -->
                <img v-if="editingStyle.styleValue.includes('http') || editingStyle.styleValue.includes('//')"
                  :src="editingStyle.styleValue" width="20" height="20" alt="icon" />
                <!-- 颜色块 -->
                <div v-else-if="editingStyle.styleValue.startsWith('color:')"
                  :style="{ backgroundColor: editingStyle.styleValue.split(':')[1], width: '16px', height: '16px', borderRadius: '50%', border: '1px solid #ddd' }">
                </div>
                <!-- 本地 png 图标（已废弃，显示占位符） -->
                <div v-else-if="editingStyle.styleValue.endsWith('.png')"
                  style="width: 20px; height: 20px; background: #d9d9d9; display: flex; align-items: center; justify-content: center; border-radius: 2px; color: #999; font-size: 10px;">
                  PNG
                </div>
              </div>
            </template>
            <template v-else-if="addOrUpdateForm.getFieldValue('type') === 'line'">
              <div style="width:40px;height:24px;margin-right: 8px;display: flex;align-items: center;overflow: hidden;">
                <svg style="width:100%; height:20px">
                  <g fill="none" :stroke="editingStyle.styleValue | lineStyle1">
                    <path :stroke-width="editingStyle.styleValue | lineStyle2" d="M0 10 l40 0"
                      :stroke-dasharray='editingStyle.styleValue | lineStyle3' />
                  </g>
                </svg>
              </div>
            </template>
            <span style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
              editingStyle.styleName }}</span>
            <a-button type="link" size="small" @click="handleSelectStyle">更改</a-button>
          </div>
          <a-button v-else type="primary" @click="handleSelectStyle">选择样式</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <style-select-modal ref="styleModal" @select="onStyleSelected"></style-select-modal>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import mixinViewModule from '@/mixin/common'
import StyleSelectModal from './module/styleSelectModal'

const columns = [
  {
    title: '图例名字',
    dataIndex: 'legendName'
  },
  {
    title: '样式',
    dataIndex: 'styleValue',
    scopedSlots: { customRender: 'styleValue' }
  },
  {
    title: '类型',
    dataIndex: 'type',
    customRender: (text) => text === 'line' ? '线' : (text === 'point' ? '点' : text)
  },
  {
    title: '排序',
    dataIndex: 'sort'
  },
  {
    title: '默认显示',
    dataIndex: 'defaultShow',
    scopedSlots: { customRender: 'defaultShow' }
  },
  {
    title: '配置项',
    dataIndex: 'config'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    StyleSelectModal
  },
  mixins: [mixinViewModule],
  name: 'GisLegendList',
  filters: {
    lineStyle1: (value) => {
      if (!value || !value.includes(';')) return '#1890ff';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return `${arrs[1]}`
    },
    lineStyle2: (value) => {
      if (!value || !value.includes(';')) return '2';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return `${arrs[0]}`
    },
    lineStyle3: (value) => {
      if (!value || !value.includes(';')) return '0';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return `${arrs[2]}`
    },
    lineStyle4: (value) => {
      if (!value || !value.includes(';')) return 'round';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return `${arrs[3]}`
    }
  },
  data () {
    return {
      queryUrl: '/manager/gis/legend/page',
      deleteUrl: '/manager/gis/legend',
      addOrUpdateUrl: '/manager/gis/legend',
      queryOneUrl: '/manager/gis/legend',
      query: {
        legendName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      editingStyle: null, // 存储当前选中的样式对象
      styleId: null,      // 存储选中的样式ID
      styleDialog: false,
      styleList: [],
      styleIndex: '',
      styleTotal: 0,
      stylePage: 1,
      borderColor: '',
      borderSize: 1,
      dasharray: 0,
      strokelinejoin: 'round'
    }
  },
  methods: {
    handleSelectStyle () {
      this.$refs.styleModal.show(this.styleId ? [this.styleId] : [])
    },
    onStyleSelected (style) {
      this.editingStyle = style
      this.styleId = style.id
    },
    edit (id) {
      this.isUpdate = false
      this.editingStyle = null
      this.styleId = null
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${id}`)
          .then(({ data }) => {
            const formData = pick(data, 'legendName', 'type', 'config', 'sort')
            formData.defaultShow = data.defaultShow === 1
            this.addOrUpdateForm.setFieldsValue(formData)
            // 确保编辑时正确回显样式信息
            if (data.style) {
              this.editingStyle = data.style
              this.styleId = data.styleId || data.style.id
            } else if (data.styleId || data.styleValue) {
              this.styleId = data.styleId
              // 如果后端没返回 style 对象，则根据顶层字段构造一个用于回显
              this.editingStyle = {
                id: data.styleId,
                styleValue: data.styleValue,
                styleName: data.styleName || data.legendName // 优先用样式名，没有则用图例名
              }
            }
          })
          .catch(() => { })
      }
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            defaultShow: values.defaultShow ? 1 : 0
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            ...params,
            styleId: this.styleId
          })
            .then(res => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    handleCancel () { }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.selected-layer {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 4px;
  border: 1px solid #e8e8e8;

  .delete-btn {
    color: #ff4d4f;
    margin-left: 8px;
  }
}
</style>
